import { useTranslation } from "react-i18next";
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { setAdminMode as setIsOpen } from 'store/slices/businessSlice';
import FAQItems from '../../Components/FAQ';
import './sass/main.scss';
import Layout from 'Components/Layout';
import { Helmet } from 'react-helmet-async';
import './FAQ.css';
import PageHeader from 'Components/PageHeader/PageHeader';

const FAQ = ({
  setIsOpen
}) => {
  const {
    t
  } = useTranslation();
  useEffect(() => {
    setIsOpen(false);
  });
  const title = 'Frequently Asked Questions';
  const description = '';
  return <Layout>
      <Helmet>
        <title>{t("FAQs")}</title>
      </Helmet>
      <PageHeader title={title} description={description} />
      <FAQItems />
    </Layout>;
};

const mapStateToProps = state => ({
  isAuthenticated: state.auth.isAuthenticated
});

const mapDispatchToProps = dispatch => ({
  setIsOpen: () => dispatch(setIsOpen(false))
});

export default connect(mapStateToProps, mapDispatchToProps)(FAQ);